export default __webpack_public_path__ + "a45aa9e7e6bf041dbc46696c6145c782.png";